import * as z from "zod/v4";

export const getShippingMethods = {
  name: "getShippingMethods" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({
    shippingMethods: z.array(
      z.object({
        id: z.string().nullable().optional(),
        title: z.string(),
        code: z.string().optional(),
        carrierIdentifier: z.string().optional(),
        serviceName: z.string().optional(),
        price: z.object({ amount: z.string(), currency: z.string() }),
      }),
    ),
  }),
};

export const getShippingMethodsSchema = { getShippingMethods };
